var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, ViewChild, Input, Inject } from '@angular/core';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { FontElementSettingModal } from '../base/font-element-setting-modal';
import { VARIABLE_SERVICE } from '../../core/variable/variable.service';
import { WordDataType } from '../../core/variable/flag-data-type';
import { VariableName } from '../../core/variable/variable-name';
import { FontSizeHelper } from '../../shared/helpers/font-size-helper';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
import { DisplayDataType } from './display-data-type-enum';
import { DataType } from '../../core/variable/data-type';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
import { AccessPermission } from '../../../../shared/fbox/fbox/access-permission';
import { NumericalOperationHelper } from '../../diagram/utils/numerical-display/numerical-operation-helper';
import { SecuritySettingAdapter } from '../shared/control/security-setting.adapter';
import { NumericalOperationType } from '../../diagram/utils/numerical-display/numerical-operation-type';
var NumericalDisplaySettingModalComponent = /** @class */ (function (_super) {
    __extends(NumericalDisplaySettingModalComponent, _super);
    function NumericalDisplaySettingModalComponent(injector, dataTypeService, accessPermissionService, numericalOperationService, variableService) {
        var _this = _super.call(this, injector, 'numericalDisplaySettingModal') || this;
        _this.dataTypeService = dataTypeService;
        _this.variableService = variableService;
        _this.dataType = WordDataType;
        _this.variableDataType = DataType;
        _this.displayDataType = DisplayDataType;
        _this.variableDisplayDataType = _this.displayDataType.DecimalSystem;
        _this.supportIntegerDigit = false;
        _this.supportFractionDigit = false;
        _this.supportNumericalOperation = false;
        _this.enableNumericalOperation = false;
        _this.numericalOperationType = NumericalOperationType;
        _this.isHexOrBinaryType = false;
        _this.showConvertTo = false;
        _this.variableTextFont = {
            content: _this.lc('ConfigureVariableName'),
            font: {
                fontSize: FontSizeHelper.defaultFontSize,
                isBold: false,
                isItalic: false,
                isUnderline: false,
                color: FontStyleHelper.defaultFontColor,
                textAlign: TextAlignHelper.AlignCenter,
                fontFamily: FontStyleHelper.defautFontFamily
            }
        };
        _this.accessPermissions = accessPermissionService.getAccessPermissions();
        _this.numericalOperations = numericalOperationService.getNumericalOperations();
        _this.accessPermissionEnum = AccessPermission;
        return _this;
    }
    Object.defineProperty(NumericalDisplaySettingModalComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(this._currentVariableId, v)) {
                return;
            }
            this._currentVariableId = v;
            this.currentVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericalDisplaySettingModalComponent.prototype, "currentVariable", {
        get: function () {
            return this._currentVariable;
        },
        set: function (v) {
            if (v === this._currentVariable) {
                return;
            }
            this._currentVariable = v;
            this.currentVariableChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericalDisplaySettingModalComponent.prototype, "selectedVariableDigitMaxLength", {
        get: function () {
            if (!this.currentVariable) {
                return undefined;
            }
            return this.dataTypeService.getValueMaxLength(this.currentVariable.dataType, this.variableDisplayDataType);
        },
        enumerable: true,
        configurable: true
    });
    NumericalDisplaySettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        this.editedComponent = editedComponent;
        this.configureId = editedComponent.configureId;
        var componentData = editedComponent.model.data;
        _super.prototype.init.call(this, editedComponent);
        this.loadAccessPermission(componentData);
        this.loadFontInfo(componentData);
        this.loadControlSetting(componentData);
        this.loadGraphSetting(componentData);
        this.loadNumericalOperationSetting(componentData);
        this.loadDynamicSetting(componentData);
        this.loadVariable(componentData);
        this.loadUnit(componentData);
        this.loadNumericalLimit(componentData);
        this.loadVariableText(componentData);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
            _this.enableSettingCmp.init(editedComponent);
            _this.isFirstLoadingVariableText = false;
        }, 500);
        this.modal.show();
    };
    NumericalDisplaySettingModalComponent.prototype.currentVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () {
                _this.isLoading = false;
            }))
                .subscribe(function (variable) {
                if ((_this.currentVariable && variable !== _this.currentVariable) || _this.unit === undefined) {
                    _this.unit = variable.unit ? variable.unit : '';
                }
                _this.currentVariable = variable;
                if (!_this.isFirstLoadingVariableText) {
                    _this.variableTextFont.content = variableId.name ? variableId.name : '';
                    _this.changeNumericalLimit();
                }
                _this.isFirstLoadingVariableText = false;
            });
        }
        else {
            // 点击清空按钮，变成null，重置单位和变量名称文字
            if (variableId === null) {
                this.variableTextFont.content = this.lc('ConfigureVariableName');
                this.unit = undefined;
            }
            this.isFirstLoadingVariableText = false;
            this.currentVariable = undefined;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.currentVariableChanged = function () {
        var variable = this.currentVariable;
        if (variable) {
            var dataType = variable.dataType;
            this.supportIntegerDigit = true;
            this.showConvertTo = variable.dataType !== this.variableDataType.Float;
            if (!this.showConvertTo) {
                this.variableDisplayDataType = this.displayDataType.DecimalSystem;
            }
            this.supportFractionDigit = this.dataTypeService.isSupportFractionDigit(dataType, this.variableDisplayDataType);
            this.supportNumericalOperation = this.dataTypeService.isSupportNumericalOperation(this.currentVariable.dataType, this.variableDisplayDataType);
            this.getNumericalLimit(this.variableDisplayDataType);
        }
        else {
            this.showConvertTo = false;
            this.supportIntegerDigit = false;
            this.supportFractionDigit = false;
            this.supportNumericalOperation = false;
            this.numericalUpperLimit = '';
            this.numericalLowerLimit = '';
            this.enableNumericalOperation = false;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.changeDisplayDataType = function (displayDataType) {
        var _this = this;
        if (!this.currentVariable) {
            return;
        }
        this.supportFractionDigit = this.dataTypeService.isSupportFractionDigit(this.currentVariable.dataType, displayDataType);
        this.isHexOrBinaryType = this.dataTypeService.isHexOrBinaryType(displayDataType);
        this.supportNumericalOperation = this.dataTypeService.isSupportNumericalOperation(this.currentVariable.dataType, displayDataType);
        this.setDefaultMinMaxValue(displayDataType);
        setTimeout(function () {
            _this.handleIntegerDigits();
        }, 100);
    };
    NumericalDisplaySettingModalComponent.prototype.integerDigitsValueChange = function (newValue) {
        if (this.currentVariable && newValue) {
            this.setDefaultMinMaxValue(this.variableDisplayDataType);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.fractionDigitsChange = function (newValue) {
        if (this.currentVariable && newValue) {
            this.setDefaultMinMaxValue(this.variableDisplayDataType);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.setDefaultMinMaxValue = function (displayDataType) {
        this.numericalUpperLimit = this.dataTypeService.getMaxValue(this.currentVariable.dataType, displayDataType, this.integerDigits, this.fractionDigits);
        this.numericalLowerLimit = this.dataTypeService.getMinValue(this.currentVariable.dataType, displayDataType, this.integerDigits, this.fractionDigits);
    };
    NumericalDisplaySettingModalComponent.prototype.numericalUpperLimitChange = function (newValue) {
        var _this = this;
        if (this.currentVariable && newValue) {
            var upperLimitValue_1;
            var maxValue_1 = this.dataTypeService.getMaxValue(this.currentVariable.dataType, this.variableDisplayDataType, this.integerDigits, this.fractionDigits);
            if (this.dataTypeService.isFloat(this.currentVariable.dataType)) {
                upperLimitValue_1 = Number(newValue.toFixed(this.fractionDigits));
            }
            else {
                upperLimitValue_1 = Number(newValue.toFixed(0));
            }
            setTimeout(function () {
                upperLimitValue_1 = upperLimitValue_1 > maxValue_1 ? maxValue_1 : upperLimitValue_1;
                _this.numericalUpperLimit = upperLimitValue_1;
            }, 0);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.numericalLowerLimitChange = function (newValue) {
        var _this = this;
        if (this.currentVariable && newValue) {
            var lowerLimitValue_1;
            var minValue_1 = this.dataTypeService.getMinValue(this.currentVariable.dataType, this.variableDisplayDataType, this.integerDigits, this.fractionDigits);
            if (this.dataTypeService.isFloat(this.currentVariable.dataType)) {
                lowerLimitValue_1 = Number(newValue.toFixed(this.fractionDigits));
            }
            else {
                lowerLimitValue_1 = Number(newValue.toFixed(0));
            }
            setTimeout(function () {
                lowerLimitValue_1 = lowerLimitValue_1 < minValue_1 ? minValue_1 : lowerLimitValue_1;
                _this.numericalLowerLimit = lowerLimitValue_1;
            }, 0);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadNumericalLimit = function (componentData) {
        if (!componentData) {
            return;
        }
        this.integerDigits = !_.isNil(componentData.integerDigits) ? componentData.integerDigits : 4;
        this.fractionDigits = !_.isNil(componentData.fractionDigits) ? componentData.fractionDigits : 0;
        this.numericalUpperLimit = this.dataTypeService.formatDisplayValue(componentData.numericalUpperLimit, +this.variableDisplayDataType);
        this.numericalLowerLimit = this.dataTypeService.formatDisplayValue(componentData.numericalLowerLimit, +this.variableDisplayDataType);
        this.isHexOrBinaryType = this.dataTypeService.isHexOrBinaryType(this.variableDisplayDataType);
    };
    NumericalDisplaySettingModalComponent.prototype.changeNumericalLimit = function () {
        this.integerDigits = 4;
        this.fractionDigits = 0;
        this.setDefaultMinMaxValue(this.variableDisplayDataType);
    };
    NumericalDisplaySettingModalComponent.prototype.getNumericalLimit = function (displayDataType) {
        if (!this.currentVariable) {
            return;
        }
        var numericalUpperLimit = this.dataTypeService.getMaxValue(this.currentVariable.dataType, displayDataType, this.integerDigits, this.fractionDigits);
        var numericalLowerLimit = this.dataTypeService.getMinValue(this.currentVariable.dataType, displayDataType, this.integerDigits, this.fractionDigits);
        if (this.numericalUpperLimit > numericalUpperLimit ||
            this.numericalUpperLimit < numericalLowerLimit || (!this.numericalUpperLimit && this.numericalUpperLimit !== 0)) {
            this.numericalUpperLimit = numericalUpperLimit;
        }
        if (this.numericalLowerLimit < numericalLowerLimit ||
            this.numericalLowerLimit > numericalUpperLimit || (!this.numericalLowerLimit && this.numericalLowerLimit !== 0)) {
            this.numericalLowerLimit = numericalLowerLimit;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.changeEnableNumericalOperation = function () {
        this.enableNumericalOperation = !this.enableNumericalOperation;
        if (this.enableNumericalOperation) {
            this.numericalOperationSetting = NumericalOperationHelper.getProportionalConversionSettings();
        }
    };
    NumericalDisplaySettingModalComponent.prototype.changeNumericalOperationType = function () {
        if (this.numericalOperationSetting.type === NumericalOperationType.ProportionalConversion) {
            this.numericalOperationSetting = NumericalOperationHelper.getProportionalConversionSettings();
        }
        else {
            this.numericalOperationSetting = NumericalOperationHelper.getZoomSettings();
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadAccessPermission = function (componentData) {
        var self = this;
        if (componentData.accessPermission) {
            self.accessPermission = componentData.accessPermission;
        }
        else {
            self.accessPermission = AccessPermission.ReadOnly;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadControlSetting = function (componentData) {
        this.securitySettingData = new SecuritySettingAdapter(componentData, true);
    };
    NumericalDisplaySettingModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadNumericalOperationSetting = function (componentData) {
        this.enableNumericalOperation = componentData.enableNumericalOperation;
        if (this.enableNumericalOperation && null != componentData.numericalOperationSetting) {
            this.numericalOperationSetting = _.cloneDeep(componentData.numericalOperationSetting);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    NumericalDisplaySettingModalComponent.prototype.loadVariable = function (componentData) {
        var _this = this;
        if (componentData.variableVersion) {
            this.currentVariableId = VariableName.tryParse(componentData.variableName, componentData.variableVersion);
        }
        else if (!_.isNil(componentData.dataSourceCode)) {
            this.variableService.getVariableName(componentData.dataSourceCode, componentData.variableName, componentData.variableGroupName).subscribe(function (value) {
                _this.currentVariableId = value;
            });
        }
        this.variableDisplayDataType = !_.isNil(componentData.displayDataType) ? componentData.displayDataType : this.displayDataType.DecimalSystem;
    };
    NumericalDisplaySettingModalComponent.prototype.loadUnit = function (componentData) {
        if (componentData.showUnit !== false) {
            this.showUnit = true;
        }
        else {
            this.showUnit = false;
        }
        this.unit = componentData.unit;
    };
    NumericalDisplaySettingModalComponent.prototype.loadVariableText = function (componentData) {
        this.showVariableText = componentData.showVariableText ? componentData.showVariableText : false;
        if (componentData.variableText) {
            this.isFirstLoadingVariableText = true;
            this.variableTextFont = _.cloneDeep(componentData.variableText);
        }
    };
    NumericalDisplaySettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    NumericalDisplaySettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    NumericalDisplaySettingModalComponent.prototype.validate = function () {
        var self = this;
        if (self.supportIntegerDigit) {
            if (self.integerDigits < 0) {
                self.message.error(self.lc('MustBePositive', self.lc('IntegerDigit')), self.lc('IntegerDigit'));
                return false;
            }
            if (self.integerDigits === 0) {
                self.message.error(self.lc('MustBePositive', self.lc('IntegerDigit')), self.lc('IntegerDigit'));
                return false;
            }
            if (self.integerDigits > self.selectedVariableDigitMaxLength) {
                self.message.error(self.lc('IntegerDigit') +
                    self.lc('MustLessThan', self.selectedVariableDigitMaxLength), self.lc('IntegerDigit'));
                return false;
            }
        }
        if (self.supportFractionDigit) {
            if (self.fractionDigits < 0 || (self.integerDigits === 0 && self.fractionDigits === 0)) {
                self.message.error(self.lc('MustBePositive', self.lc('FractionDigit')), self.lc('FractionDigit'));
                return false;
            }
            if (self.fractionDigits > self.selectedVariableDigitMaxLength) {
                self.message.error(self.lc('FractionDigit') +
                    self.lc('MustLessThan', self.selectedVariableDigitMaxLength), self.lc('FractionDigit'));
                return false;
            }
            if (self.fractionDigits + self.integerDigits > self.selectedVariableDigitMaxLength) {
                self.message.error('', self.lc('IntegerFractionDigitTooLong', self.selectedVariableDigitMaxLength));
                return false;
            }
        }
        if (self.integerDigits === 0) {
            self.message.error(self.lc('MustBePositive', self.lc('IntegerDigit')), self.lc('IntegerDigit'));
            return false;
        }
        if (self.currentVariable) {
            var numericalUpperLimit = this.dataTypeService.formatToDecimal(self.numericalUpperLimit, self.currentVariable.dataType);
            var numericalLowerLimit = this.dataTypeService.formatToDecimal(self.numericalLowerLimit, self.currentVariable.dataType);
            if (numericalLowerLimit > numericalUpperLimit || numericalLowerLimit === numericalUpperLimit) {
                self.message.error(self.lc('LimitWarningMessage', self.lc('NumericalLowerLimit'), self.lc('NumericalUpperLimit')));
                return false;
            }
        }
        if (self.enableNumericalOperation && self.numericalOperationSetting.type === NumericalOperationType.ProportionalConversion) {
            if (Number(self.numericalOperationSetting.settings.lowerLimit) >= Number(self.numericalOperationSetting.settings.upperLimit)) {
                self.message.error(self.lc('LimitWarningMessage', self.lc('ProportionalLowerLimit'), self.lc('ProportionalUpperLimit')));
                return false;
            }
        }
        return true;
    };
    NumericalDisplaySettingModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    NumericalDisplaySettingModalComponent.prototype.saveDigitInfo = function () {
        var self = this;
        if (self.supportIntegerDigit) {
            self.saveComponentProperty('integerDigits', self.integerDigits);
        }
        else {
            delete self.currentEditedPartData.integerDigits;
        }
        if (self.supportFractionDigit) {
            self.saveComponentProperty('fractionDigits', self.fractionDigits);
        }
        else {
            delete self.currentEditedPartData.fractionDigits;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.saveVariableInfo = function () {
        if (this._currentVariable) {
            this.currentEditedPartData.dataType = this._currentVariable.dataType;
        }
        this.deleteComponentProperty('dataSourceCode');
        this.deleteComponentProperty('variableGroupName');
        this.saveComponentProperty('variableName', this.currentVariableId ? this.currentVariableId.name : '');
        this.saveComponentProperty('variableVersion', this.currentVariableId ? this.currentVariableId.variableVersion : undefined);
        this.saveComponentProperty('displayDataType', this.variableDisplayDataType);
    };
    NumericalDisplaySettingModalComponent.prototype.saveAccessPermission = function () {
        this.saveComponentProperty('accessPermission', this.accessPermission);
    };
    NumericalDisplaySettingModalComponent.prototype.saveControlSetting = function () {
        this.controlSettingCmp.save(this.editedComponent.model, this.accessPermission !== AccessPermission.ReadOnly);
    };
    NumericalDisplaySettingModalComponent.prototype.saveNumericalLimitInfo = function () {
        if (this.currentVariable) {
            this.saveComponentProperty('numericalUpperLimit', this.dataTypeService.formatToDecimal(this.numericalUpperLimit, this.variableDisplayDataType));
        }
        else {
            delete this.currentEditedPartData.numericalUpperLimit;
        }
        if (this.currentVariable) {
            this.saveComponentProperty('numericalLowerLimit', this.dataTypeService.formatToDecimal(this.numericalLowerLimit, this.variableDisplayDataType));
        }
        else {
            delete this.currentEditedPartData.numericalLowerLimit;
        }
    };
    NumericalDisplaySettingModalComponent.prototype.saveNumericalOperationSetting = function () {
        var self = this;
        if (self.supportNumericalOperation) {
            self.saveComponentProperty('enableNumericalOperation', self.enableNumericalOperation);
        }
        else {
            delete self.currentEditedPartData.enableNumericalOperation;
        }
        if (this.enableNumericalOperation) {
            this.saveComponentProperty('numericalOperationSetting', this.numericalOperationSetting);
        }
        else {
            this.deleteComponentProperty('numericalOperationSetting');
        }
    };
    NumericalDisplaySettingModalComponent.prototype.saveUnit = function () {
        this.saveComponentProperty('showUnit', this.showUnit);
        this.saveComponentProperty('unit', this.unit);
    };
    NumericalDisplaySettingModalComponent.prototype.saveVariableText = function () {
        this.saveComponentProperty('showVariableText', this.showVariableText);
        this.saveComponentProperty('variableText', this.variableTextFont);
    };
    NumericalDisplaySettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    NumericalDisplaySettingModalComponent.prototype.save = function () {
        var self = this;
        if (!self.validate()) {
            return;
        }
        self.saving = true;
        this.currentDiagram.startTransaction('numericalDisplay settings');
        if (this.accessPermission !== AccessPermission.ReadOnly) {
            if (!this.enableSettingCmp.save()) {
                this.saving = false;
                this.setActiveTab(2);
                return;
            }
        }
        if (!this.displaySettingCmp.save()) {
            self.saving = false;
            this.setActiveTab(3);
            return;
        }
        self.saveDigitInfo();
        self.saveVariableInfo();
        self.saveUnit();
        self.saveFontInfo();
        self.saveAccessPermission();
        self.saveControlSetting();
        self.saveGraphSetting();
        self.saveNumericalLimitInfo();
        self.saveNumericalOperationSetting();
        self.saveDynamicSetting();
        self.saveVariableText();
        this.currentDiagram.commitTransaction('numericalDisplay settings');
        self.close();
    };
    NumericalDisplaySettingModalComponent.prototype.onHidden = function () {
        this.currentVariableId = undefined;
        _super.prototype.onHidden.call(this);
    };
    NumericalDisplaySettingModalComponent.prototype.handleIntegerDigits = function () {
        if (this.integerDigits > this.selectedVariableDigitMaxLength) {
            this.integerDigits = this.selectedVariableDigitMaxLength;
        }
    };
    __decorate([
        ViewChild('locationXInput', { static: false })
    ], NumericalDisplaySettingModalComponent.prototype, "locationXInput", void 0);
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], NumericalDisplaySettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('enableSettingCmp', { static: false })
    ], NumericalDisplaySettingModalComponent.prototype, "enableSettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], NumericalDisplaySettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('controlSettingCmp', { static: false })
    ], NumericalDisplaySettingModalComponent.prototype, "controlSettingCmp", void 0);
    __decorate([
        Input()
    ], NumericalDisplaySettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], NumericalDisplaySettingModalComponent.prototype, "viewHeight", void 0);
    NumericalDisplaySettingModalComponent = __decorate([
        Component({
            selector: 'numerical-display-setting-modal',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } ",
                ".numericalDisplaySettingModal { .numerical-tooltip { color: #999; padding-top: 10px; } .font-padding { padding-top: 10px; } .hexColor { color: red; } .modal-content { width: 600px; top: 30px; } .numerical-operation { padding-left: 10px; margin-bottom: 10px; } .ui-dropdown .ui-dropdown-label { padding: 0.42em !important; } } .conversion-type { label { margin-right: 20px; } } textarea.no-resize { height: 30px; resize: none; padding: 3px !important; } .variable-text-input { width: 100%; } .warning-text { color: red; font-size: 14px; padding: 5px; } .design-nav-link { .fe-vertical-label{ display: inline-block; } .nav.nav-tabs { .nav-link { color: #666 !important; border-bottom: 1px solid transparent; } .active { border-color: #fff; color: #3695ff !important; border-bottom: 1px solid #3695ff !important; } .nav-link:hover { border-color: white; color: #3695ff; } } }"],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"numericalDisplaySettingModal\" class=\"modal fade numericalDisplaySettingModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content element-setting-base\" [busyIf]=\"isLoading\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #numericalDisplaySettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"NumericalDisplay\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let permision of accessPermissions\"> <input type=\"radio\" name=\"accessOptions\" [value]=\"permision.key\" [(ngModel)]=\"accessPermission\" /> <span>{{ls(\"FBox\",permision.value)}}</span> </label> </div> <div class=\"fe-transverse-label\"> <div class=\"fe-transverse-title\"> {{lc(\"VariableName\")}}: </div> <div class=\"fe-transverse-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> <div class=\"fe-transverse-label clearfix margin-top-5 conversion-type\" *ngIf=\"showConvertTo\"> <div class=\"fe-transverse-title\"> {{lc(\"ConvertTo\")}}： </div> <div class=\"fe-transverse-component\"> <label (click)=\"changeDisplayDataType(displayDataType.DecimalSystem)\"> <input type=\"radio\" name=\"conversion-type\" [value]=\"displayDataType.DecimalSystem\"  [(ngModel)]=\"variableDisplayDataType\"> <span>{{lc(\"DecimalSystem\")}}</span> </label> <label (click)=\"changeDisplayDataType(displayDataType.HexadecimalSystem)\"> <input type=\"radio\" name=\"conversion-type\" [value]=\"displayDataType.HexadecimalSystem\" [(ngModel)]=\"variableDisplayDataType\"> <span>{{lc(\"HexadecimalSystem\")}}</span> </label> <label (click)=\"changeDisplayDataType(displayDataType.Binary)\"> <input type=\"radio\" name=\"conversion-type\" [value]=\"displayDataType.Binary\" [(ngModel)]=\"variableDisplayDataType\"> <span>{{lc(\"Binary\")}}</span> </label> </div> </div> <div class=\"margin-top-10 clearfix\" *ngIf=\"supportFractionDigit||supportIntegerDigit\"> <div class=\"fe-vertical-label fe-half-line\" *ngIf=\"supportIntegerDigit\"> <div class=\"fe-vertical-title\">{{lc(\"IntegerDigit\")}}:</div> <input type=\"number\" name=\"IntegerDigit\" class=\"fe-vertical-input\" [(ngModel)]=\"integerDigits\" (ngModelChange)=\"integerDigitsValueChange($event)\" min=\"1\" max=\"{{selectedVariableDigitMaxLength}}\" (blur)=\"handleIntegerDigits()\" required> </div> <div class=\"fe-vertical-label fe-half-line\" *ngIf=\"supportFractionDigit\"> <div class=\"fe-vertical-title\">{{lc(\"FractionDigit\")}}:</div> <input type=\"number\" name=\"FractionDigit\" class=\"fe-vertical-input\" [(ngModel)]=\"fractionDigits\" (ngModelChange)=\"fractionDigitsChange($event)\" required> </div> </div> <div class=\"margin-top-10 clearfix\" *ngIf=\"currentVariable\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"NumericalLowerLimit\")}} <span *ngIf=\"isHexOrBinaryType\" class=\"hexColor\">(HEX)</span>:</div> <input type=\"number\" *ngIf=\"!isHexOrBinaryType\" name=\"NumericalLowerLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalLowerLimit\" (ngModelChange)=\"numericalLowerLimitChange($event)\" required> <input type=\"text\" *ngIf=\"isHexOrBinaryType\" name=\"NumericalLowerLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalLowerLimit\" onkeypress=\"if (event.keyCode<48 || (event.keyCode>57 && event.keyCode < 65) || (event.keyCode>70  && event.keyCode < 97) || event.keyCode > 102) event.returnValue=false\" required> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"NumericalUpperLimit\")}} <span *ngIf=\"isHexOrBinaryType\" class=\"hexColor\">(HEX)</span>:</div> <input type=\"number\" *ngIf=\"!isHexOrBinaryType\" name=\"NumericalUpperLimit\" class=\"fe-vertical-input\" [value]=\"numericalUpperLimit\" [(ngModel)]=\"numericalUpperLimit\" (ngModelChange)=\"numericalUpperLimitChange($event)\" required> <input type=\"text\" *ngIf=\"isHexOrBinaryType\" name=\"NumericalUpperLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalUpperLimit\" onkeypress=\"if (event.keyCode<48 || (event.keyCode>57 && event.keyCode < 65) || (event.keyCode>70  && event.keyCode < 97) || event.keyCode > 102) event.returnValue=false\" required> </div> </div> <div class=\"fe-modal-body margin-top-10\"> <div class=\"fe-option-head\" *ngIf=\"supportNumericalOperation\"> <label> <input type=\"checkBox\" [checked]=\"enableNumericalOperation\" (change)=\"changeEnableNumericalOperation()\" /> <span>{{lc('EnableNumericalOperation')}}</span> </label> </div> <div class=\"fe-modal-content\" *ngIf=\"enableNumericalOperation\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let operation of numericalOperations\"> <input type=\"radio\" name=\"numericalOperationRadio\" [value]=\"operation.key\" [(ngModel)]=\"numericalOperationSetting.type\" (change)=\"changeNumericalOperationType()\" /> <span>{{lc(operation.value)}}</span> </label> </div> <div class=\"fe-radio-select-body clearfix\" *ngIf=\"numericalOperationSetting.type == numericalOperationType.ProportionalConversion\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"ProportionalLowerLimit\")}}:</div> <input type=\"number\" name=\"ProportionalLowerLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalOperationSetting.settings.lowerLimit\" required> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"ProportionalUpperLimit\")}}:</div> <input type=\"number\" name=\"ProportionalUpperLimit\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalOperationSetting.settings.upperLimit\" required> </div> <div class=\"numerical-tooltip margin-top-10\">{{lc(\"ProportionalConversionTipInfo\")}}</div> </div> <div class=\"fe-radio-select-body clearfix\" *ngIf=\"numericalOperationSetting.type == numericalOperationType.Zoom\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"Gain\")}}:</div> <input type=\"number\" name=\"Gain\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalOperationSetting.settings.gain\" required> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"Offset\")}}:</div> <input type=\"number\" name=\"Offset\" class=\"fe-vertical-input\" [(ngModel)]=\"numericalOperationSetting.settings.offset\" required> </div> <div class=\"numerical-tooltip margin-top-10\"> {{lc(\"ZoomTipInfo1\")}} <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{lc(\"ZoomTipInfo2\")}} </div> </div> </div> </div> <div class=\"fe-vertical-label\"> <label for=\"show-variable-text\"> <input type=\"checkbox\" id=\"show-variable-text\" name=\"show-variable-text\" [(ngModel)]=\"showVariableText\"> <span>{{lc(\"DisplayVariableName\")}}</span> </label> </div> <div class=\"fe-vertical-label margin-top-10\" *ngIf=\"showVariableText && variableTextFont\"> <input type=\"text\" name=\"variable-text\" class=\"variable-text-input\" maxlength=\"200\" [(ngModel)]=\"variableTextFont.content\" required> <div *ngIf=\"!variableTextFont.content\" class=\"warning-text\">{{lc(\"VariableNameNoEmpty\")}}</div> </div> <div class=\"form-group textToolBarPadding font-padding\" *ngIf=\"showVariableText && variableTextFont\"> <font-setting [font]=\"variableTextFont.font\" [textAlignEnabled]=\"true\"></font-setting> </div> <div class=\"fe-vertical-label\"> <label for=\"show-unit\"> <input type=\"checkbox\" id=\"show-unit\" name=\"show-unit\" [(ngModel)]=\"showUnit\"> <span>{{lc(\"DisplayUnit\")}}</span> </label> </div> <div class=\"fe-vertical-label\" *ngIf=\"showUnit\"> <div class=\"fe-vertical-title\"> {{lc(\"Unit\")}}: </div> <textarea class=\"fe-vertical-input no-resize\" rows=\"6\" name=\"Unit\" #textInput maxlength=\"500\" [(ngModel)]=\"unit\"> </textarea> </div> <div class=\"form-group textToolBarPadding font-padding\"> <font-style [(fontSize)]=\"fontSize\" [(fontColor)]=\"fontColor\" [(textAlign)]=\"textAlign\" [(isUnderline)]=\"isUnderline\" [(fontStyle)]=\"fontStyle\"></font-style> </div> </div> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('ControlSetting')}}\" customClass=\"m-tabs__item\" [disabled]=\"accessPermission == accessPermissionEnum.ReadOnly\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <enable-setting #enableSettingCmp></enable-setting> <control-setting #controlSettingCmp [data]=\"securitySettingData\"></control-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!numericalDisplaySettingForm.form.valid || dynamicValidatoinResult || !variableTextFont.content\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div> "
        }),
        __param(4, Inject(VARIABLE_SERVICE))
    ], NumericalDisplaySettingModalComponent);
    return NumericalDisplaySettingModalComponent;
}(FontElementSettingModal));
export { NumericalDisplaySettingModalComponent };
